<div class="avisos-section">
  <!--
    Wrapper para hover detection (pausar/retomar autoplay) e ancoragem da
    barra de progresso visual. Cobre o header (titulo + barra) e o
    carrossel para que mouseenter/mouseleave pausem o timer em qualquer
    interacao do usuario com a area de avisos.
  -->
  <div class="aviso-carrossel-wrapper"
       (mouseenter)="onMouseEnter()"
       (mouseleave)="onMouseLeave()">

    <!--
      Header da secao: titulo "Avisos" a esquerda e barra de progresso
      compacta do autoplay a direita, na mesma linha.
    -->
    <header class="avisos-header">
      <h3 class="avisos-header__titulo">
        <i class="pi pi-bell"></i>
        {{ 'dashboard.texts.avisos' | translate }}
      </h3>

      <!--
        Barra de progresso do autoplay (compacta, no header).
        - Largura proporcional ao tempo restante (0..100%).
        - `--pausado` remove a transicao para congelar a barra na pausa.
        - `pi pi-pause` aparece a esquerda da barra durante a pausa.
        - So renderiza quando ha mais de 1 aviso (sem autoplay = sem barra).
      -->
      <div class="aviso-timer" *ngIf="avisos && avisos.length > 1">
        <i class="pi pi-pause aviso-timer__icone-pause"
           *ngIf="pausado"
           [attr.aria-label]="'dashboard.texts.pausado' | translate"></i>
        <div class="aviso-timer__track">
          <div class="aviso-timer__barra"
               [style.width.%]="progresso"
               [class.aviso-timer__barra--pausado]="pausado">
          </div>
        </div>
      </div>
    </header>
    <p-carousel
      [value]="avisosRotacionados"
      [numVisible]="3"
      [numScroll]="1"
      [responsiveOptions]="responsiveOptions"
      [circular]="false"
      [showIndicators]="true"
      [showNavigators]="avisos.length > 1"
      [page]="paginaAtual"
      (onPage)="onPaginaTrocada($event)"
      styleClass="avisos-carousel">
      <ng-template pTemplate="item" let-aviso>
        <!--
          O primeiro item da lista e propositalmente null: representa o slot
          esquerdo vazio na pagina inicial, fazendo o aviso[0] aparecer no
          centro (destacado). Renderizamos um placeholder invisivel para
          manter as dimensoes do slot.
        -->
        <ng-container *ngIf="aviso; else slotVazio">
          <article class="aviso-card" (click)="onAvisoClicado(aviso)">
            <div class="aviso-card__imagem">
              <ng-container *ngIf="deveExibirImagem(aviso); else placeholderImg">
                <img [src]="getImagemBannerUrl(aviso.imagemBanner)"
                     alt=""
                     [attr.aria-label]="aviso.titulo"
                     class="aviso-card__img"
                     (error)="onImagemErro(aviso.id)">
              </ng-container>
              <ng-template #placeholderImg>
                <span class="aviso-card__placeholder"
                      [attr.aria-label]="'dashboard.texts.sem_imagem' | translate">
                  <i class="pi pi-image"></i>
                </span>
              </ng-template>
            </div>

            <div class="aviso-card__corpo">
              <h4 class="aviso-card__titulo">{{ aviso.titulo }}</h4>
              <p class="aviso-card__descricao">
                <strong>{{ 'dashboard.texts.descricao_label' | translate }}:</strong>
                {{ aviso.descricao }}
              </p>
            </div>

            <footer class="aviso-card__rodape">
              <span class="aviso-card__icone-tipo" [ngSwitch]="aviso.tipoAviso">
                <i *ngSwitchCase="'VIDEO'" class="pi pi-video"></i>
                <i *ngSwitchCase="'LINK'" class="pi pi-link"></i>
                <i *ngSwitchCase="'DIALOGO'" class="pi pi-comment"></i>
                <i *ngSwitchCase="'CHAT_WHATSAPP'" class="pi pi-whatsapp"></i>
                <i *ngSwitchCase="'PERFIL_INSTAGRAM'" class="pi pi-instagram"></i>
                <i *ngSwitchCase="'TUTORIAL'" class="pi pi-question-circle"></i>
                <i *ngSwitchDefault class="pi pi-bell"></i>
              </span>
              <span class="aviso-card__badge-data" *ngIf="aviso.dataInicial">
                {{ aviso.dataInicial | date:'dd/MM/yyyy' }}
              </span>
            </footer>
          </article>
        </ng-container>
        <ng-template #slotVazio>
          <div class="aviso-card-slot-vazio" aria-hidden="true"></div>
        </ng-template>
      </ng-template>
    </p-carousel>
  </div>
</div>

<!-- Dialog para aviso tipo DIALOGO -->
<p-dialog [(visible)]="showDialog" [modal]="true" [style]="{ width: '450px' }">
  <p>{{ textoDialogo }}</p>
</p-dialog>
